import type { JSONContent } from "@tiptap/core";
import { Table, renderTableToMarkdown } from "@tiptap/extension-table";

/**
 * The document editor's table, saved so a "|" inside a cell is written as "\|".
 *
 * ⚠️ The stock serializer wrote it bare, so the next load split the cell in two
 *    and dropped its end ("Junk Removal Services Tulsa OK | Same Day Junk
 *    Hauling" in KB-008 lost its second half, and the cell beside it). The pipe
 *    is swapped for a placeholder the text renderer leaves alone (it would escape
 *    a backslash written here), then escaped in the finished table.
 */
const PIPE = "\uE000";

const hidePipes = (node: JSONContent): JSONContent => ({
  ...node,
  ...(node.type === "text" && node.text ? { text: node.text.replace(/\|/g, PIPE) } : {}),
  ...(node.content ? { content: node.content.map(hidePipes) } : {}),
});

export const PipeSafeTable = Table.extend({
  renderMarkdown: (node: JSONContent, helpers: Parameters<typeof renderTableToMarkdown>[1]) =>
    renderTableToMarkdown(hidePipes(node), helpers).split(PIPE).join("\\|"),
});
